// extracted by mini-css-extract-plugin
export default {"propsCardHeader":"PropsCardHeader_propsCardHeader__jCcab","closeBtn":"PropsCardHeader_closeBtn__IiW1e","closeIconButton":"PropsCardHeader_closeIconButton__GW-+l"};